import { Permission, RolePermissions, User } from './types/types'
import { assertNever } from './utils'

/* It doesn't seem possible to satisfy the `typedef` TSLint rule for this
function. Maybe it's worth revisiting when a later version of TypeScript is
available?
(Current TS just has generally poor support for higher-order functions...)
 */

// tslint:disable-next-line typedef
export function createPermissionLookup<PermissionsUnion extends string>(
  table: Record<PermissionsUnion, RolePermissions>,
) {
  function hasPermission(permission: PermissionsUnion): (user: User) => boolean
  function hasPermission(permission: PermissionsUnion, user: User): boolean
  // tslint:disable-next-line typedef
  function hasPermission(permission: PermissionsUnion, user?: User) {
    if (user) {
      return checkPermission(table, permission, user)
    }
    return function _hasPermission(forUser: User): boolean {
      return checkPermission(table, permission, forUser)
    }
  }

  return hasPermission
}

function checkPermission<PermissionsUnion extends string>(
  table: Record<PermissionsUnion, RolePermissions>,
  permission: PermissionsUnion,
  user: User,
): boolean {
  switch (user.type) {
    case 'FailedToLogIn':
    case 'LoggingIn':
    case 'NotLoggedIn':
      return false
    case 'FailedToLogout':
    case 'LoggedIn':
      const isPermittedBy = table[permission]
      return (
        (user.hasBusinessAdminRole && isPermittedBy.businessAdmin) ||
        (user.hasITAdminRole && isPermittedBy.itAdmin) ||
        (user.hasTVModeRole && isPermittedBy.tvMode) ||
        (user.hasRiskUserRole && isPermittedBy.riskUser)
      )
    default:
      return assertNever(user)
  }
}

// Should this be on the model?
export const appPermissions = createPermissionLookup<Permission>({
  canRedButton: {
    businessAdmin: true,
    itAdmin: false,
    riskUser: false,
    tvMode: false
  },
  canViewAlerts: {
    businessAdmin: true,
    itAdmin: true,
    riskUser: true,
    tvMode: true,
  },
  canViewClientDetails: {
    businessAdmin: true,
    itAdmin: true,
    riskUser: true,
    tvMode: false,
  },
  canViewMainChart: {
    businessAdmin: true,
    itAdmin: true,
    riskUser: true,
    tvMode: false
  },
  canViewTvModeAndSettings: {
    businessAdmin: true,
    itAdmin: true,
    riskUser: true,
    tvMode: true,
  }
})
